export default __webpack_public_path__ + "static/profile-4283db8c5d92aaca55614f91a81a060d.jpg";